
import MindDisplayType from "../../../../viewmodel/datatype/MindDisplayType"
import NodeLayoutType from "../../../../viewmodel/datatype/NodeLayoutType"
import LineLayout from "../../../../viewmodel/datatype/LineLayout"
import MindElementType from "../../../../viewmodel/datatype/MindElementType"
import MindElementShapeType from "../../../../viewmodel/datatype/MindElementShapeType"
import LineMindTypeNodeUnit from "../../../../viewmodel/mindelementdata/LineMindTypeNodeUnit"
import Colors from "../../../../utils/Colors"
import LineMindTypeNode from "../../../../viewmodel/mindelementdata/LineMindTypeNode"
import MindBGStripesType from "../../../../viewmodel/datatype/MindBGStripesType"
if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0
) {
    var { ipcRenderer } = window.require("electron");

}
import {
    postMindmapNew,
} from "../../../../common/netWork/mind_map_api";
import Strings from "../../../../utils/Strings"
import IdGenerator from "../../../../viewmodel/core/base/IdGenerator"
import SettingData from "../../../../viewmodel/core/minddata/SettingData"
import MindElementAlignmentType from "../../../../viewmodel/datatype/MindElementAlignmentType"
import Config from "../../../../core/core/calcule/Config"
import MindType from "../../../datatype/MindType"
import MindElementCalculation from "../../../../core/core/calcule/elementCalculation/MindElementCalculation"
import MindDateFormat from "../../../../core/core/dataformat/MindDateFormat"
import AiSubectData from "./AiSubectData"

class AiMessageToMap {

    constructor(message) {
        this.value = message;
        this.lineSeparatorByN = "\n";
        this.lineSeparatorByR = "\r";
        this.lineSeparatorByRN = "\r\n";
        this.lineSeparatorByNR = "\n\r";

        this.lineIndentByT = "\t";
        this.lineIndentByXmind = "#";
        this.lineIndentByXingmind = "*";
        this.lineIndentByArrow = "> ";
        this.lineIndentBySpace = "  ";
        this.lineIndentBySpace2 = "　　";

        this.lineIndentByTitleForMarkdown = "__";
        this.title = "";
        this.dataList = new Array();
        this.mainMindNodeUnit;
        this.mindType = MindType.LINE_MAP;
        this.mindDisplayType = MindDisplayType.MindMap;
        this.layout = NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE;
        this.lineLayout = LineLayout.CURVE_LINE;
        this.mindElementShape = MindElementShapeType.Semicircle;
        this.mindSubElementShape = MindElementShapeType.CornerShadow;
        this.name = "";
        this.subtitle = "";
        this.baseLevel = 0;
        this.mindBGColor = Colors.white;
        this.settingData = new SettingData();
        this.styleIndex = 1;
        this.lineColors = [];

        this.subjectList = [];
        this.aiMessageToMapInterface;
        this.initData();
    }

    initData() {
        IdGenerator.shared.resetId()
        let rainbowColoresIndex = Math.min(Math.ceil(Math.random() * (Colors.RainbowColores.length - 1)), Colors.RainbowColores.length - 1);
        let lineColors = Colors.RainbowColores[rainbowColoresIndex];
        if (lineColors.length > 0) {
            this.settingData.lineColor = []
            for (let index = 1; index < lineColors.length; index++) {
                this.settingData.lineColor.push(lineColors[index]);
            }
        }
        this.lineColors = lineColors

        this.mainMindNodeUnit = new LineMindTypeNodeUnit(this.mindBGColor, MindType.LINE_MAP, 1, false);
        this.mainMindNodeUnit.setMindBGColor(this.mainMindNodeUnit.mindMapStyleColor.getMindMapFillColor());
        this.mainMindNodeUnit.setMindDisplayType(this.mindDisplayType);
        this.mainMindNodeUnit.setElementLayout(this.layout, true);
        this.mainMindNodeUnit.setLineColors(this.settingData.lineColor)
        this.mainMindNodeUnit.globalLineLayout = this.lineLayout;
        this.mainMindNodeUnit.createRootNode();
    }

    format(aiMessageToMapInterface) {
        this.aiMessageToMapInterface = aiMessageToMapInterface;
        this.dataSeparator(this.value);

        let nodeCount = this.subjectList.length;
        if (nodeCount == 0 || this.mainMindNodeUnit.rootTreeNode == null) {
            this.aiMessageToMapInterface.onFormatCompleted(false, "");
            return;
        }
        
        this.layout = NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE;
        this.lineLayout = LineLayout.STRAIGHT_CURVE_LINE;
        this.mainMindNodeUnit.setElementLayout(this.layout, true);
        this.mainMindNodeUnit.globalLineLayout = this.lineLayout;
        
        this.creatNode();        
        let that = this
        this.setMapStyle(); 
        setTimeout(() => {            
            that.save();
        }, 200);
               
    }

    save() {
        let mindDateFormat = new MindDateFormat();
        mindDateFormat.mindBGColor = Colors.white;
        mindDateFormat.mindDisplayType = this.mindDisplayType;
        mindDateFormat.version = Config.MindFormatVersion;
        mindDateFormat.mindGlobalAudio = "";
        mindDateFormat.mindBGStripesType = MindBGStripesType.NonExistent;
        mindDateFormat.settingData = this.settingData
        mindDateFormat.styleIndex = this.styleIndex;
        mindDateFormat.mindDisplayType = this.mindDisplayType;

        let freeNodes = new Array();
        mindDateFormat = mindDateFormat.setDatas(
            this.mainMindNodeUnit.rootTreeNode,
            this.mainMindNodeUnit.lineMindElementDataDict.values(),
            this.mainMindNodeUnit.generalizationLineMindElementDataDict.values(),
            this.mainMindNodeUnit.generalizationMindElementDataDict.values(),
            freeNodes,
            new Array())
            .setLayout(this.layout, this.lineLayout);


        let mindNodeJson = mindDateFormat.toJSONString();
        let mindTitle = new Strings().isEmpty(this.name) ? "MindMap" : this.name;
        IdGenerator.shared.resetId()
        if (mindNodeJson != null) { //创建导图到服务器，content= mindNodeJson, ...根据服务器返回，跳转进入导图
            const obj = {
                parentEntityId: '',
                name: mindTitle,
                content: mindNodeJson,
                type: this.mindType,
                cover: '',
                subtitle: '',
            }
            postMindmapNew(
                obj,
                (res) => {
                    let mindId = res.id;
                    this.aiMessageToMapInterface.onFormatCompleted(true, mindId);
                },
                (error) => {
                    this.aiMessageToMapInterface.error(error.desc);
                }
            );
        }
    }

    creatNode() {
        let nodeCount = this.subjectList.length;
        if (this.mainMindNodeUnit.rootTreeNode == null || nodeCount == 0) {
            return;
        }
        let rootData = this.mainMindNodeUnit.rootTreeNode;
        rootData.value.textContent.text = this.subjectList[0].getSubjectText();
        rootData.value.mindElementShape = this.mindElementShape;
        rootData.value.alignmentType = MindElementAlignmentType.MIDDLE;
        MindElementCalculation.set(rootData.value).caluleTextForData();
        this.name = rootData.value.textContent.text;
        this.mainMindNodeUnit.setElementLayout(this.layout, true);
        this.mainMindNodeUnit.refreshLayout(false, this.settingData);

        let rootChildCount = this.subjectList[0].getSubjectTextList().length;
        for (let index = 0; index < rootChildCount; index++) {
            let child = this.subjectList[0].getSubjectTextList()[index];
            this.addNode(this.mainMindNodeUnit.rootTreeNode, child);
        }
    }

    addNode(parent, data) {
        let newNode = this.mainMindNodeUnit.addChildMindElement(parent.value.id);
        newNode.value.textContent.text = data.getSubjectText();
        if (newNode.value.type == MindElementType.SUBJECT || newNode.value.type == MindElementType.SON_SUBJECT) {
            newNode.value.mindElementShape = MindElementShapeType.Underline;
        }
        MindElementCalculation.set(newNode.value).caluleTextForData();
        let count = data.getSubjectTextList().length;
        for (let index = 0; index < count; index++) {
            let child = data.getSubjectTextList()[index];
            this.addNode(newNode, child);
        }
    }

    setMapStyle() {
        if (this.mainMindNodeUnit.rootTreeNode == null || this.mainMindNodeUnit.rootTreeNode.isEmpty()) {
            return;
        }
        this.mainMindNodeUnit.setElementLayout(NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE, true);
        this.mainMindNodeUnit.refreshLayout(true, this.settingData);
        this.mainMindNodeUnit.onSelectedRainbowr(this.lineColors);
        let heightCount = 0
        let subjectTextList = this.subjectList[0].getSubjectTextList()
        for (let index = 0; index < subjectTextList.length; index++) {
            heightCount += subjectTextList[index].getHeightChildCount()
        }

        if (this.subjectList[0].getSubjectTextList().length < 4 || heightCount < 25 ||
            (this.subjectList[0].getSubjectTextList().length == 5 && heightCount < 30)) {
            this.layout = NodeLayoutType.LAYOUT_BRACKETS_RIGHT;
            this.lineLayout = LineLayout.RIGHT_ANGLE_CORNER_LINE;
        } else if (this.subjectList[0].getSubjectTextList().length == 4 ||
                    this.subjectList[0].getSubjectTextList().length > 5) {
            this.layout = NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE; 
            this.lineLayout = LineLayout.STRAIGHT_CURVE_LINE;
        } else {
            this.layout = NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE;
            this.lineLayout = LineLayout.STRAIGHT_CURVE_LINE;
        }     
        
        if (this.layout == NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE) {
            this.mainMindNodeUnit.setElementLayout(this.layout, false);
            this.mainMindNodeUnit.refreshLayout(true, this.settingData);
            this.mainMindNodeUnit.setFramework(0, this.settingData);
            this.styleIndex = 0
        } else if (this.layout == NodeLayoutType.LAYOUT_RIGHT) {
            this.mainMindNodeUnit.setElementLayout(this.layout, false);
            this.mainMindNodeUnit.refreshLayout(true, this.settingData);
            this.mainMindNodeUnit.setFramework(7, this.settingData);
            this.styleIndex = 7
        } else {
            this.mainMindNodeUnit.setElementLayout(this.layout, false);
            this.mainMindNodeUnit.refreshLayout(true, this.settingData);
            this.mainMindNodeUnit.setFramework(12, this.settingData);
            this.styleIndex = 12
        }
        
        if (this.mainMindNodeUnit.rootTreeNode.children.length > 2) {
            this.mainMindNodeUnit.onSelectedRainbowr(this.lineColors);
        }
        for (let index = 0; index < this.mainMindNodeUnit.rootTreeNode.children.length; index++) {
            this.setSonNodeTextColor(this.mainMindNodeUnit.rootTreeNode.children[index])
        }
        this.mainMindNodeUnit.rootTreeNode.value.alignmentType = MindElementAlignmentType.MIDDLE;
    }

    setSonNodeTextColor(node) {
        if (node == null || node.isEmpty()) {
            return
        }
        // console.log("textColor-->", node.value.textContent.text, node.value.backgroundColorAlpha,
        //     Colors.isDarkColor(node.value.backgroundColor, 0.35), Colors.isDarkColor(node.value.backgroundColor, 0.4),
        //     Colors.isDarkColor(node.value.textContent.textColor)
        // );
        
        if (node.value.type == MindElementType.SON_SUBJECT &&
            node.value.backgroundColorAlpha <= 0.35 && 
            !Colors.isClear(node.value.backgroundColor) && 
            Colors.isDarkColor(node.value.backgroundColor, 0.4) &&
            Colors.isDarkColor(node.value.textContent.textColor)) {
            node.value.textContent.textColor = Colors.getColorIntValue(Colors.getNumberToRgbDark(node.value.backgroundColor, 0.5))
        }
        for (let index = 0; index < node.children.length; index++) {
            this.setSonNodeTextColor(node.children[index])
        }
    }

    dataSeparator(value) {
        if (!value || value.length === 0) {
            return;
        }
        let trimmedMessage = "";

        for (let index = 0; index < value.length; index++) {
            const currentChar = value.charAt(index);
            if (currentChar === '-' && trimmedMessage.length > 2 &&
                (trimmedMessage.endsWith("}") || trimmedMessage.endsWith("]") || trimmedMessage.endsWith(")") ||
                    trimmedMessage.endsWith("} ") || trimmedMessage.endsWith("] ") || trimmedMessage.endsWith(") ") ||
                    trimmedMessage.endsWith("}  ") || trimmedMessage.endsWith("]  ") || trimmedMessage.endsWith(")  ")) &&
                !trimmedMessage.endsWith("-") && !trimmedMessage.endsWith("\n")) {
                trimmedMessage += "\n";
            }
            trimmedMessage += currentChar;
        }

        // 按行分割消息
        const lines = trimmedMessage.split("\n");
        const stack = [];
        const levelStack = [];
        const subjectList = this.subjectList; // 用于存储最终主题列表

        for (const line of lines) {
            if (line.trim() === "") {
                continue; // 跳过空行
            }

            // 解析当前行的层级和内容
            let level = 0;
            let content = line.trim();

            // 检测层级标识（以"-"开头）
            while (content.startsWith("-")) {
                level++;
                content = content.substring(1).trim();
            }

            // 提取主题文本
            const subjectText = this.extractSubjectText(content);
            if (subjectText === "") {
                continue;
            }

            // 创建新的主题对象（模拟 AiSubectData）
            let currentSubject = new AiSubectData(0, subjectText, []);
            if (level === 0) {
                // 中心主题，直接添加到列表
                subjectList.push(currentSubject);
                stack.length = 0; // 清空栈
                levelStack.length = 0;
                stack.push(currentSubject);
                levelStack.push(level);
            } else {
                // 处理子主题：弹出栈顶直到当前层级大于栈顶层级
                while (levelStack.length > 0 && level <= levelStack[levelStack.length - 1]) {
                    stack.pop();
                    levelStack.pop();
                }

                if (stack.length > 0) {
                    // 添加到父主题的子主题列表
                    stack[stack.length - 1].sonSubjectList.push(currentSubject);
                    stack.push(currentSubject);
                    levelStack.push(level);
                }
            }
        }
    }

    /**
     * 从内容中提取主题文本，去掉包裹符号
     */
    extractSubjectText(content = "") {
        if (content.startsWith("{") && content.endsWith("}")) {
            return content.substring(1, content.length - 1).trim();
        } else if (content.startsWith("[") && content.endsWith("]")) {
            return content.substring(1, content.length - 1).trim();
        } else if (content.startsWith("(") && content.endsWith(")")) {
            return content.substring(1, content.length - 1).trim();
        }
        return content.trim();
    }

    createATagJump(url) {
        const a = document.createElement('a');//创建a标签浏览器不会阻止弹出窗口
        a.setAttribute('href', url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
        }, 5000);
    }
}
export default AiMessageToMap